export default __webpack_public_path__ + "static/media/twinstarProtectUltra.b957a535.jpg";